import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureInvite } from '../lib/invitations';

export function InviteAttribution() {
  const { search } = useLocation();
  useEffect(() => { captureInvite(search); }, [search]);
  return null;
}
